import { takeLatest, put, call, takeEvery } from 'redux-saga/effects';
import { LOADER_CLOSE, LOADER_OPEN } from '../actions';

import supervisorStats from '../../api/supervisorStats';
import {
  ACCESS_STATISTICS_LIST_GET,
  ACTIVITY_LIST_GET,
  ACTIVITY_STATISTICS_LIST_GET,
  CATEGORY_LIST_GET,
  CATEGORY_STATISTICS_LIST_GET,
  COURSE_STATISTICS_LIST_GET,
  TUTOR_LIST_GET,
  TUTOR_STATISTICS_LIST_GET,
  LOGS_LIST_GET,
  LAST_CACHE_INVALIDATE_GET,
  CACHE_INVALIDATE,
} from '../actions/supervisorStats';
import { errorHandling } from '../../../utils/errors';

function* getAccessStatisticsList({ filters }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      supervisorStats.getAccessStatisticsList,
      filters
    );
    yield put({ type: ACCESS_STATISTICS_LIST_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > supervisorStats > getAccessStatisticsList', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* getAccessStatisticsListWatch() {
  yield takeLatest(
    ACCESS_STATISTICS_LIST_GET._REQUEST,
    getAccessStatisticsList
  );
}

function* getActivityStatisticsList({ filters }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      supervisorStats.getActivityStatisticsList,
      filters
    );
    yield put({ type: ACTIVITY_STATISTICS_LIST_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > supervisorStats > getActivityStatisticsList', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* getActivityStatisticsListWatch() {
  yield takeLatest(
    ACTIVITY_STATISTICS_LIST_GET._REQUEST,
    getActivityStatisticsList
  );
}

function* getActivityList({ filters }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response, pager } = {} } = yield call(
      supervisorStats.getActivityList,
      filters
    );
    yield put({ type: ACTIVITY_LIST_GET._SUCCESS, response, pager });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > supervisorStats > getActivityList', err);
    errorHandling(err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* getActivityListWatch() {
  yield takeLatest(ACTIVITY_LIST_GET._REQUEST, getActivityList);
}

function* getCategoryStatisticsList({ filters }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      supervisorStats.getCategoryStatisticsList,
      filters
    );
    yield put({ type: CATEGORY_STATISTICS_LIST_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > supervisorStats > getCategoryStatisticsList', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* getCategoryStatisticsListWatch() {
  yield takeLatest(
    CATEGORY_STATISTICS_LIST_GET._REQUEST,
    getCategoryStatisticsList
  );
}

function* getCategoryList({ filters }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response, pager } = {} } = yield call(
      supervisorStats.getCategoryList,
      filters
    );
    yield put({ type: CATEGORY_LIST_GET._SUCCESS, response, pager });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > supervisorStats > getCategoryList', err);
    errorHandling(err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* getCategoryListWatch() {
  yield takeLatest(CATEGORY_LIST_GET._REQUEST, getCategoryList);
}

function* getTutorStatisticsList() {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      supervisorStats.getTutorStatisticsList
    );
    yield put({ type: TUTOR_STATISTICS_LIST_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > supervisorStats > getTutorStatisticsList', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* getTutorStatisticsListWatch() {
  yield takeLatest(TUTOR_STATISTICS_LIST_GET._REQUEST, getTutorStatisticsList);
}

function* getTutorList({ filters }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response, pager } = {} } = yield call(
      supervisorStats.getTutorList,
      filters
    );
    yield put({
      type: TUTOR_LIST_GET._SUCCESS,
      response,
      pager,
      only_filters: filters?.only_filters,
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > supervisorStats > getTutorList', err);
    errorHandling(err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* getTutorListWatch() {
  yield takeLatest(TUTOR_LIST_GET._REQUEST, getTutorList);
}

function* getCourseStatisticsList({ filters }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      supervisorStats.getCourseStatisticsList,
      filters
    );
    yield put({ type: COURSE_STATISTICS_LIST_GET._SUCCESS, response, filters });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > supervisorStats > getCourseStatisticsList', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* getCourseStatisticsListWatch() {
  yield takeEvery(COURSE_STATISTICS_LIST_GET._REQUEST, getCourseStatisticsList);
}

function* getLogsList({ filters }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      supervisorStats.getLogsList,
      filters
    );
    yield put({ type: LOGS_LIST_GET._SUCCESS, response, filters });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > supervisorStats > getLogsList', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* getLogsListWatch() {
  yield takeLatest(LOGS_LIST_GET._REQUEST, getLogsList);
}

function* getLastCacheInvalidate({ cacheTag }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      supervisorStats.getLastCacheInvalidate,
      cacheTag
    );
    yield put({ type: LAST_CACHE_INVALIDATE_GET._SUCCESS, response, cacheTag });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > supervisorStats > getLastCacheInvalidate', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* getLastCacheInvalidateWatch() {
  yield takeEvery(LAST_CACHE_INVALIDATE_GET._REQUEST, getLastCacheInvalidate);
}

function* cacheInvalidate({ payload }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      supervisorStats.cacheInvalidate,
      payload
    );
    yield put({ type: CACHE_INVALIDATE._SUCCESS, response, payload });
    if (response?.result) {
      yield put({
        type: LAST_CACHE_INVALIDATE_GET._REQUEST,
        cacheTag: payload.cache_tag,
      });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > supervisorStats > cacheInvalidate', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* cacheInvalidateWatch() {
  yield takeEvery(CACHE_INVALIDATE._REQUEST, cacheInvalidate);
}

export default [
  getAccessStatisticsListWatch(),
  getActivityStatisticsListWatch(),
  getActivityListWatch(),
  getCategoryStatisticsListWatch(),
  getCategoryListWatch(),
  getTutorStatisticsListWatch(),
  getTutorListWatch(),
  getCourseStatisticsListWatch(),
  getLogsListWatch(),
  getLastCacheInvalidateWatch(),
  cacheInvalidateWatch(),
];
